export enum LandingPageType {
    Metro = 1,
    Widget = 2,
}
